import React, { useEffect, useState } from 'react';
import { Alert, Card, CardBody } from 'reactstrap';
import { reportDate, useReportClock } from '../../reportClock';
import { loadDashboardKpiData, formatReportingFreshnessLabel } from '../../MainPage/activityData';

export default function LiveReportingHealth() {
  const now = useReportClock();
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');
  useEffect(() => {
    let active = true;
    loadDashboardKpiData(new Date(), { skipCache: true }).then(data => {
      if (active) { setResult({ data, checkedAt: new Date() }); setError(''); }
    }).catch(() => {
      if (active) setError('La lecture en direct est indisponible. La fraîcheur des données ne peut pas être confirmée.');
    });
    return () => { active = false; };
  }, [now]);
  return <Card><CardBody>
    <h2>État des données en direct — {reportDate(now)}</h2>
    <p>Actualisation automatique chaque minute · America/Toronto</p>
    {error ? <Alert color="danger">{error}</Alert> : result ? <>
      <p>Dernière lecture réussie : {result.checkedAt.toLocaleString('fr-CA', { timeZone: 'America/Toronto' })}</p>
      <p>{formatReportingFreshnessLabel(result.data.freshness)}</p>
      <p>Synchronisation : {result.data.freshness.hasSyncIssue || result.data.freshness.hasEmailSyncIssue
        ? 'Anomalie signalée par le service de rapports'
        : result.data.freshness.status === 'fresh' ? 'Données récentes' : 'Fraîcheur à vérifier'}</p>
    </> : <p>Lecture des données en cours…</p>}
    <p>Ce contrôle mesure la disponibilité et la fraîcheur du reporting. Il ne constitue pas un nouvel audit de sécurité.</p>
  </CardBody></Card>;
}
